<template>
  <div>
    <Header></Header>

    <div class="wrapper">
      <div class="top">
        <p class="col-12 top-nav text-left"><span class="index">首页</span><span>&gt;</span><span class="second">常见问题</span></p>
        <div class="row justify-content-between">
          <div class="col-md-3 col-12 selec">
            <p class="title text-left">常见问题</p>
            <!--<p class="green-block"></p>-->
            <p class="condition all active"><span @click="showKind(0)">全部</span></p>
            <p class="condition prod"><span @click="showKind(1)">产品相关</span></p>
            <p class="condition apply"><span @click="showKind(2)">申请相关</span></p>
            <p class="condition repay"><span @click="showKind(3)">还款相关</span></p>
          </div>
          <div class="col-md-7 col-11 text-left QA">
            <!--产品相关-->
            <p class="subtitle prod">及时雨现有哪些贷款品种？</p>
            <p class="desc prod">企业贷：解决中小企业及工商个体户在经营过程中的短时资金短缺问题。</p>

            <p class="subtitle prod">及时雨各类贷款有哪些期限可以申请？</p>
            <p class="desc prod">企业贷借款期限有1个月、3个月、6个月、9个月、12个月可申请。</p>

            <p class="subtitle prod">及时雨各类贷款可申请的最高金额是多少？</p>
            <p class="desc prod">企业贷最高金额一般不超过500万元。</p>

            <p class="subtitle prod">借款多久能够到账？</p>
            <p class="desc prod">申请后2-5个工作日内可放款。</p>

            <p class="subtitle prod">额度如何提高？</p>
            <p class="desc prod">额度提升一般根据客户的征信情况及收入情况综合判定。</p>

            <p class="subtitle prod">可以同时借多笔款项吗？</p>
            <p class="desc prod">可以，一笔借款也可以分多次提款。</p>

            <p class="subtitle prod">还款后还能再借吗？</p>
            <p class="desc prod">客户经理会在到期前提前做好续贷审批工作，待贷款结清后，仍可根据最新的审批额度及条件发放新贷款</p>

            <p class="subtitle prod">从及时雨申请的贷款是否上征信？</p>
            <p class="desc prod">如通过银行机构放款，贷款会上征信，但利率会比较低；如通过及时雨自有资金放款的，可以不上征信，但利率会有所上浮</p>

            <!--申请相关-->
            <p class="subtitle apply">可以通过哪些方式申请贷款？</p>
            <p class="desc apply">及时雨小贷随时欢迎客户于以下几种方式申请贷款，包括：</p>
            <p class="desc apply">(1)在此服务号留下您的借款需求</p>
            <p class="desc apply">(2)联系我司客户经理</p>
            <p class="desc apply">(3)电话申请 ：4008-212-999</p>
            <p class="desc apply">(4)通过及时雨小贷网站申请</p>

            <p class="subtitle apply">企业贷申请有什么条件？</p>
            <p class="desc apply">a.申请人年龄：满18周岁，不大于60周岁</p>
            <p class="desc apply">b.企业经营地址须在上海市内，不接受超出上海市范围的企业</p>
            <p class="desc apply">c.企业成立须满18个月（营业执照上成立日期）</p>
            <p class="desc apply">d.限制性行业：钢贸、光伏、大宗贸易、房地产开发、公立学校及医院、政府单位、国有企业、采矿、夜总会、歌舞厅、卡拉OK厅、电子游戏厅、赌博、军工、毒品、色情行业、高污染高耗能及国家公布的产能过剩等行业</p>
            <p class="desc apply">e.个人征信、企业征信无当前逾期</p>

            <p class="subtitle apply">申请及时雨各类贷款需要提供房产抵押么？</p>
            <p class="desc apply">无须房产抵押。若客户可以提供资产抵押或资产证明，可以为贷款申请增信，提高客户评级。</p>

            <p class="subtitle apply">信用卡逾期会对我申请贷款有影响么？</p>
            <p class="desc apply">我司在审批时不会因为客户信用卡曾有逾期就把用户“一棒子打死”。在审核过程中判断用户的信用度时，信用记录仅作部分参考，客户的实际工作情况及家庭情况也是非常重要的参考依据。</p>

            <p class="subtitle apply">及时雨的贷款产品是否对客户的开票和纳税有要求？</p>
            <p class="desc apply">及时雨更关注用款企业的实际经营，主要根据经营收入、资产和负债三方面确认额度，对企业的开票和纳税没有具体要求，没有开票或部分开票的企业都可以纳入公司准入要求。</p>

            <p class="subtitle apply">我在上海没有房产可以贷款吗？</p>
            <p class="desc apply">可以，只要企业经营情况正常，负债率低，用途合理，也可以获批信用贷款额度。</p>

            <!--还款相关-->
            <p class="subtitle repay">及时雨各类贷款的还款方式有哪些？</p>
            <p class="desc repay">等额本息和先息后本两种方式可选择。</p>

            <p class="subtitle repay">借款费用从哪天开始计收？</p>
            <p class="desc repay">自借款成功发放至您的银行卡当日开始计收。</p>

            <p class="subtitle repay">可以提前还清借款吗?利息如何计算？</p>
            <p class="desc repay">企业贷不可以提前还款。</p>

          </div>
        </div>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
  import Header from './Header'
  import Footer from './Footer'
  import $ from 'jquery'

  export default {
    name: "questions",
    components:{Header,Footer},
    methods:{
      showKind: function(k) {
        $('.condition').removeClass('active');
        if(k === 0){
          $('.QA .desc').show();
          $('.QA .subtitle').show();
          $('.condition.all').addClass('active');
        }else{
          $('.QA .desc').hide();
          $('.QA .subtitle').hide();
          switch (k){ //1产品相关  2申请相关  3还款相关
            case 1:
              $('.QA .prod').show();
              $('.condition.prod').addClass('active');
              break;

            case 2:
              $('.QA .apply').show();
              $('.condition.apply').addClass('active');
              break;

            case 3:
              $('.QA .repay').show();
              $('.condition.repay').addClass('active');
              break;
          }
        }
      }
    }
  }
</script>

<style scoped lang="less">
  p{margin:0;}
  //pc、laptop
  @media screen and (min-width: 769px) {
    .top{
      width:1300px !important;
      /*padding-left:50px;*/
    }
  }

  //phone
  @media screen and (max-width: 768px) {
    .wrapper{
      padding-top:90px;
    }
    .top .condition{
      text-align: left !important;
    }
  }


  .top{
    margin: 60px auto 250px;
    padding-left:50px;

    .top-nav{
      /*font-size:20px;*/
      margin-bottom:48px;

      .index{
        margin-right:10px;
        color:#01A494;
      }
      .second{
        margin-left:10px;
      }
    }
    .row{
      margin:0;
    }
    .selec{
      margin-bottom:100px;
    }

    .title{
      font-size:56px;
      margin-bottom:20px;
    }
    .condition{
      padding-right:60px;
      text-align: right;
      margin-bottom:14px;
      font-weight:800;
      cursor:pointer;

      &.active{
        color: #01A494;
      }
    }

    .subtitle{
      font-size:20px;
      margin-bottom:17px;
      margin-top:48px;
      font-weight:bold;
      &:first-child{
        margin-top:0;
      }
    }
    .desc{
      font-size:16px;
      margin-bottom: 12px;
      color: rgba(0,0,0,.6)
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Questions.vue